import { render } from "./MensajeTables.vue?vue&type=template&id=fb834408"
import script from "./MensajeTables.vue?vue&type=script&lang=js"
export * from "./MensajeTables.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__